/* lua.js generated code undefined */

let Base = unpack(require("clover/logic/userTagData/UserTagBase"))[0]
let Tag = xClass("ThirtyDayPaymentTagNew", Base)
Tag.prototype.init = function () {
    let self = this
    self.record = table()
    self.config = table()
    UserDeal.getInstance().on(UserDealEvent.BuyGoods, handler(self, self.logBuyGoods))
}
Tag.prototype.logBuyGoods = function (event) {
    let self = this
    if (event.payType === UserDealPayType.kCoin || event.payType === UserDealPayType.kCash) {
        return 
    }
    table.insert(self.record, table(
        [1, "price", event.price],
        [1, "time", Localhost.time()],
        [1, "goodsId", event.goodsId],
        [1, "num", event.num],
        [1, "type", event.payType],
        [1, "totalPrice", event.totalPrice]
    ))
}
Tag.prototype.convertOnlineRecord = function (data) {
    let self = this
    let ret = table()
    for (let i = 1, v = data.cashLogs[1]; v; i++, v = data.cashLogs[i]) {
        table.insert(ret, table(
            [1, "price", v.price],
            [1, "time", tonumber(v.time) || 0],
            [1, "goodsId", v.goodsId],
            [1, "num", v.num || 1],
            [1, "type", v.type],
            [1, "totalPrice", (v.num || 1) * v.price]
        ))
    }
    return table([1, "record", ret])
}
Tag.prototype.refresh = function (data) {
    let self = this
    if (data.record) {
        self.record = table()
        for (let k in data.record) {
            let v = data.record[k]
            if ($null(v)) continue
            table.insert(self.record, clone(v))
        }
    }
    if (data.config) {
        self.config = table()
        for (let k in data.config) {
            let v = data.config[k]
            if ($null(v)) continue
            self.config[tonumber(k) || 0] = table([1, "min", tonumber(v.min) || 0], [1, "max", tonumber(v.max) || 0])
        }
    }
}
function getDayStartTimeByTS(ts) {
    let utc8TimeOffset = 57600
    let oneDaySeconds = 86400
    return ts - ((ts - utc8TimeOffset) % oneDaySeconds)
}
Tag.prototype.getTag = function () {
    let self = this
    let dayStart = getDayStartTimeByTS(Localhost.timeInSec())
    let [first, last] = [(dayStart - 86400 * 30) * 1000, (dayStart + 86400) * 1000]
    let record = 0
    table.each(self.record, function (v) {
        if (v.time >= first && v.time < last) {
            if (v.totalPrice === null) {
                v.totalPrice = (v.num || 1) * (v.price || 0)
            }
            record = record + v.totalPrice
        }
    })
    return record
}
Tag.prototype.encode = function () {
    let self = this
    let data = table()
    data.record = self.record
    data.config = self.config
    return data
}
module.exports = Tag
